/**
 * Safely read the human-readable `detail` from a thrown API error. Mutations
 * surface `unwrap`'s normalized ApiError, but React Query types the callback
 * error as `Error`, so we narrow structurally rather than cast.
 */
export function apiErrorDetail(err: unknown): string | undefined {
  if (err && typeof err === "object" && "detail" in err) {
    const detail = (err as { detail?: unknown }).detail;
    if (typeof detail === "string") return detail;
  }
  return undefined;
}
